import { toast } from 'sonner';

import { useAxios } from '@/hooks/useAxios';
import { queryClient } from '@/queryclient';
import { useMutation } from '@/utils/api';

interface GlobalEnabledStatus {
  plugin: string;
  enabled: boolean;
}

interface ToggleGlobalParams {
  enabled: boolean;
}

export function useToggleGlobalEnabled() {
  const axios = useAxios({ doNotImpersonate: true });

  return useMutation<GlobalEnabledStatus, Error, ToggleGlobalParams>({
    defaultErrorMessage: 'Failed to update global discovery state',
    mutationFn: async ({ enabled }) => {
      const { data } = await axios.put('/enrichment/global/enabled', {
        enabled,
      });
      return data;
    },
    onSuccess: data => {
      toast.success(
        data.enabled
          ? 'All discovery plugins re-enabled'
          : 'All discovery plugins disabled globally'
      );
      queryClient.invalidateQueries({
        queryKey: ['enrichment', 'global', 'enabled'],
      });
      queryClient.invalidateQueries({
        queryKey: ['enrichment', 'enabled'],
      });
    },
  });
}
